import { render, staticRenderFns } from "./AppCells.vue?vue&type=template&id=447ddf8b&scoped=true&"
import script from "./AppCells.vue?vue&type=script&lang=js&"
export * from "./AppCells.vue?vue&type=script&lang=js&"
import style0 from "./AppCells.vue?vue&type=style&index=0&id=447ddf8b&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ddf8b",
  null
  
)

export default component.exports